import { combineReducers, createSlice } from "@reduxjs/toolkit";
import { HOME_TAB } from "libs/constant/Step";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import {
  setHomeTab,
  setSmartFormBackStep,
  setSmartFormStep
} from "redux/modules/uiSlice";
import {
  addExtension,
  addPopupSmartForm,
  addSmartForm, addWorkPermit, checkRequestSmartForm,
  checkSmartO, checkWorkPermit, getCoditionType,
  getCoditionVisa,
  getDocumentRequired,
  getDocumentrequiredbydraftid, getDocumentRequiredPreApprove, getExtension,
  getListSmartForm,
  getSmartForm,
  getSmartFormFieldConfig,
  getSmartServiceList, getSmartServiceListLTR, getSmartserviceListLTRExtra, reqdoclogList,
  smartFormChange,
  submitSmartForm,
  submitSmartO,
  uploadPassport
} from "redux/modules/visaForm/actions";

export const smartServiceSlice = createSlice({
  name: "visaForm/smartService",
  initialState: LoadingAdapter.getInitialState({ data: [] }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getSmartServiceList, builder);
  },
});

export const documentRequiredSlice = createSlice({
  name: "visaForm/documentRequired",
  initialState: LoadingAdapter.getInitialState({ data: [] }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getDocumentRequired, builder);
    LoadingAdapter.applyAsyncBuilder(getDocumentRequiredPreApprove, builder);
    LoadingAdapter.applyAsyncBuilder(getDocumentrequiredbydraftid, builder);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({ data: [] });
      }
    });
  },
});

// export const documentrequiredbydraftid = createSlice({
//   name: "visaForm/documentrequiredbydraftid",
//   initialState: LoadingAdapter.getInitialState({ data: [] }),
//   reducers: {
//     clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
//     clearAsyncState: LoadingAdapter.clearAsyncState,
//   },
//   extraReducers: (builder) => {
//     LoadingAdapter.applyAsyncBuilder(getDocumentrequiredbydraftid, builder);
//     builder.addCase(setHomeTab, (state, action) => {
//       if (
//         action.payload === HOME_TAB.INFORMATION ||
//         action.payload === HOME_TAB.SMART_VISA_SERVICE
//       ) {
//         return LoadingAdapter.getInitialState({ data: [] });
//       }
//     });
//   },
// });

export const coditionVisaSlice = createSlice({
  name: "visaForm/coditionVisa",
  initialState: LoadingAdapter.getInitialState({ data: [] }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getCoditionVisa, builder);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({ data: [] });
      }
    });
  },
});

export const coditionTypeSlice = createSlice({
  name: "visaForm/coditionType",
  initialState: LoadingAdapter.getInitialState({ data: [] }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getCoditionType, builder);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({ data: [] });
      }
    });
  },
});

export const currentDocumentSlice = createSlice({
  name: "visaForm/currentDocumnent",
  initialState: LoadingAdapter.getInitialState({
    smartserviceId: "",
    ConditionType: "",
    passport: null,
    smartform: {},
  }),
  reducers: {
    clearAll: () =>
      LoadingAdapter.getInitialState({
        smartserviceId: "",
        ConditionType: "",
        passport: null,
        smartform: {},
      }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
    setSmartServiceId(state, action) {
      state.smartserviceId = action.payload;
    },
    setConditionType(state, action) {
      state.ConditionType = action.payload;
    },
    setConditionTypeExtension(state, action) {
      const detail =
        state.smartform?.detail?.map((detail) => {
          if (detail.smartName === "ConditionType") {
            return {
              ...detail,
              value: action.payload,
            };
          }
          return detail;
        }) ?? [];

      return {
        ...state,
        smartform: {
          ...state.smartform,
          detail,
        },
      };
    },
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(uploadPassport, builder, ["passport"]);
    LoadingAdapter.applyAsyncBuilder(getSmartForm, builder, ["smartform"]).onSuccess((newState, action) => {
      newState.smartserviceId = action.payload.smartserviceId;
    });

    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({
          smartserviceId: "",
          ConditionType: "",
          passport: null,
          smartform: {},
        });
      }
    });
    builder.addCase(smartFormChange.fulfilled, (state, action) => {
      state.smartserviceId = action.payload.smartserviceId;
    });
    builder.addCase(getExtension.fulfilled, (state, action) => {
      state.smartserviceId = action.payload.smartserviceId;
      state.smartform = action.payload;
    });
    builder.addCase(addExtension.fulfilled, (state, action) => {
      state.smartserviceId = "ea67ab08-5953-4453-0830-28ed243a8d38";
    });
    builder.addCase(setSmartFormBackStep, LoadingAdapter.clearAsyncState);
    builder.addCase(setSmartFormStep, LoadingAdapter.clearAsyncState);
  },
});

export const fieldConfigSlice = createSlice({
  name: "visaForm/fieldConfig",
  initialState: LoadingAdapter.getInitialState({
    data: {
      defaultType: [],
      extraType: [],
    },
  }),
  reducers: {
    clearAll: () =>
      LoadingAdapter.getInitialState({ smartserviceId: "", passport: null }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getSmartFormFieldConfig, builder, [
      "data",
    ]);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({
          smartserviceId: "",
          passport: null,
        });
      }
    });
  },
});

export const addSmartFormSlice = createSlice({
  name: "visaForm/addSmartForm",
  initialState: LoadingAdapter.getInitialState({
    data: {},
  }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: {} }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
    setSmartFormSetDraftId(state, action) {
      console.log(action);
      state.data.draftId = action.payload;
    },
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(addPopupSmartForm, builder, ["data"]);
    LoadingAdapter.applyAsyncBuilder(addSmartForm, builder, ["data"]);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({ data: {} });
      }
    });

    builder.addCase(getSmartForm.fulfilled, (state, action) => {
      state.data.draftId = action.payload.draftId;
    });
    builder.addCase(smartFormChange.fulfilled, (state, action) => {
      state.data.draftId = action.payload.draftId;
    });
    builder.addCase(getExtension.fulfilled, (state, action) => {
      state.data.draftId = action.payload.draftId;
    });
    builder.addCase(addExtension.fulfilled, (state, action) => {
      state.data.draftId = action.payload.draftId;
    });
    // builder.addCase(addWorkPermit.fulfilled, (state, action) => {
    //   state.data.draftId = action.payload.draftId;
    // });
    LoadingAdapter.applyAsyncBuilder(addWorkPermit, builder, ["data"]);
  },
});

export const listSmartFormSlice = createSlice({
  name: "visaForm/list",
  initialState: LoadingAdapter.getInitialState({
    data: [],
  }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getListSmartForm, builder, ["data"]);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({ data: [] });
      }
    });
  },
});

export const submitSmartFormSlice = createSlice({
  name: "visaForm/submitSmartForm",
  initialState: LoadingAdapter.getInitialState({
    data: {},
  }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(submitSmartForm, builder, ["data"]);
    LoadingAdapter.applyAsyncBuilder(submitSmartO, builder, ["data"]);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({ data: [] });
      }
    });
  },
});

export const smartFormChangeSlice = createSlice({
  name: "visaForm/smartFormChange",
  initialState: LoadingAdapter.getInitialState({
    data: {},
  }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(smartFormChange, builder, ["data"]);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({ data: [] });
      }
    });
  },
});

export const extensionSlice = createSlice({
  name: "visaForm/extension",
  initialState: LoadingAdapter.getInitialState({ data: {} }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: {} }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getExtension, builder);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({ data: {} });
      }
    });
  },
});

export const addExtensionSlice = createSlice({
  name: "visaForm/addExtension",
  initialState: LoadingAdapter.getInitialState({ data: {} }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: {} }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(addExtension, builder);
    builder.addCase(setHomeTab, (state, action) => {
      if (
        action.payload === HOME_TAB.INFORMATION ||
        action.payload === HOME_TAB.SMART_VISA_SERVICE
      ) {
        return LoadingAdapter.getInitialState({ data: {} });
      }
    });
  },
});

export const checkSmartOSlice = createSlice({
  name: "visaForm/checkSmartO",
  initialState: LoadingAdapter.getInitialState({ data: {} }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: {} }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(checkSmartO, builder);
  },
});

export const reqdoclogListSlice = createSlice({
  name: "visaForm/reqdoclogList",
  initialState: LoadingAdapter.getInitialState({
    list: [],
  }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ list: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(reqdoclogList, builder, ["list"]);
  },
});

export const checkRequestSmartFormSlice = createSlice({
  name: "visaForm/checkRequestSmartForm",
  initialState: LoadingAdapter.getInitialState({
    data: {},
  }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: {} }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(checkRequestSmartForm, builder, ["data"]);
  },
});

export const LTRSliceList = createSlice({
  name: "visaForm/getSmartServiceListLTR",
  initialState: LoadingAdapter.getInitialState({
    data: [],
  }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getSmartServiceListLTR, builder, ["data"]);
  },
});

export const smartServiceListLTRExtra = createSlice({
  name: "visaForm/getSmartserviceListLTRExtra",
  initialState: LoadingAdapter.getInitialState({
    data: [],
  }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: [] }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getSmartserviceListLTRExtra, builder, ["data"]);
  },
});

export const checkWorkPermitSlice = createSlice({
  name: "visaForm/checkWorkPermit",
  initialState: LoadingAdapter.getInitialState({
    data: {},
  }),
  reducers: {
    clearAll: () => LoadingAdapter.getInitialState({ data: {} }),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(checkWorkPermit, builder, ["data"]);
  },
});

export const {
  setSmartServiceId,
  setConditionType,
  setConditionTypeExtension,
} = currentDocumentSlice.actions;

export const { setSmartFormSetDraftId } = addSmartFormSlice.actions;

export default combineReducers({
  currentDocument: currentDocumentSlice.reducer,
  smartService: smartServiceSlice.reducer,
  documentRequired: documentRequiredSlice.reducer,
  coditionVisa: coditionVisaSlice.reducer,
  coditionType: coditionTypeSlice.reducer,
  fieldConfig: fieldConfigSlice.reducer,
  addSmartForm: addSmartFormSlice.reducer,
  list: listSmartFormSlice.reducer,
  submit: submitSmartFormSlice.reducer,
  smartFormChange: smartFormChangeSlice.reducer,
  smartFormExtension: extensionSlice.reducer,
  addExtension: addExtensionSlice.reducer,
  checkSmartO: checkSmartOSlice.reducer,
  reqdoclogList: reqdoclogListSlice.reducer,
  checkRequestSmartForm: checkRequestSmartFormSlice.reducer,
  LTRList: LTRSliceList.reducer,
  smartServiceListLTRExtra: smartServiceListLTRExtra.reducer,
  checkWorkPermit: checkWorkPermitSlice.reducer,
});
